var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { WifiOnboardComponent } from './wifi-onboard.component';
import * as fromStore from '@ibe/store/index';
import * as BookedTripActions from '@ibe/store/actions/booked-trip.actions';
import { SidebarService } from '@ibe/services/ui';
import { BookedTrip, Flight, PassengerFlightInfo } from '@ibe/models';
import { ActivatedRoute, Router } from '@angular/router';
import { takeWhile } from 'rxjs/operators';
import { BookingService, MybService } from '@ibe/services';
import { environment } from '@environments/environment';
import { FormBuilder } from '@angular/forms';
var TAPWifiOnboardComponent = /** @class */ (function (_super) {
    __extends(TAPWifiOnboardComponent, _super);
    function TAPWifiOnboardComponent(store, route, router, bookingService, fb, sidebarService, mybService) {
        var _this = _super.call(this, sidebarService, route, router, bookingService, mybService) || this;
        _this.store = store;
        _this.fb = fb;
        _this.notificationDuration = 2.5; // in seconds
        // Initialization values
        _this.isAlive = true;
        _this.bookedTrip$ = _this.store.select(fromStore.getSelectedBookedTrip);
        _this.currency = environment.currency;
        _this.vouchersCollection = [
            {
                name: 'Pack S - 400MB',
                value: 's',
                price: 20
            },
            {
                name: 'Pack M - 1GB',
                value: 's',
                price: 40
            },
            {
                name: 'Pack L - 2GB',
                value: 'l',
                price: 60
            }
        ];
        _this.hasChanges$ = combineLatest([_this.route.params, _this.bookedTrip$]);
        _this.formsPerPassenger = [];
        return _this;
    }
    TAPWifiOnboardComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
    };
    TAPWifiOnboardComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.hasChanges$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (_a) {
            var routeParams = _a[0], trip = _a[1];
            if (routeParams) {
                _this.params = routeParams;
                if (_this.booking)
                    _this.setParams();
            }
            if (trip) {
                _this.booking = trip;
                if (_this.params)
                    _this.setParams();
            }
        });
        this.options = this.TAP_getAvailableOptions();
    };
    TAPWifiOnboardComponent.prototype.setParams = function () {
        var _this = this;
        this.flightIdentifier = this.params.flight;
        this.flight = this.booking.flights.find(function (value) { return value.id === _this.params.flight; });
        this.otherFlights = this.booking.flights.filter(function (value) { return value.id !== _this.params.flight; });
        this.passengers = this.flight.passengerInfo;
        var temp = [];
        this.passengers.forEach(function (passenger) {
            _this.formsPerPassenger.push(_this.createFormGroup());
            if (!passenger.stops.filter(function (cur) { return cur.wifi; }).length) {
                var stops = passenger.stops.map(function (cur) { return Object.assign({}, cur, { wifi: [] }); });
                passenger = Object.assign(new PassengerFlightInfo(null, null), passenger, { stops: stops });
            }
            temp.push(passenger);
        });
        this.passengers = temp;
    };
    TAPWifiOnboardComponent.prototype.createFormGroup = function () {
        return this.fb.group({
            wifiAdd: null
        });
    };
    TAPWifiOnboardComponent.prototype.TAP_getAvailableOptions = function () {
        var options = [];
        for (var i = 0; i < this.vouchersCollection.length; i++) {
            options.push({ label: this.vouchersCollection[i].name + ' (' + (this.vouchersCollection[i].price * this.flight.stops_labels.length) + this.currency.symbol + ')', value: this.vouchersCollection[i].value });
        }
        return options;
    };
    /**
 * Returns if any items were added in this sidebar
 */
    TAPWifiOnboardComponent.prototype.TAP_hasAddedVouchers = function () {
        if (this.passengers) {
            return this.passengers.some(function (passenger) { return passenger.stops.some(function (stop) { return stop.wifi && stop.wifi.length > 0; }); });
        }
        return false;
    };
    TAPWifiOnboardComponent.prototype.TAP_hasNextFlight = function () {
        if (this.booking)
            return this.booking.flights.length > 1 && this.otherFlights.filter(function (cur) { return cur.canEditPassengerInfo(cur.status); }).length;
        return false;
    };
    /**
 *
 * @param passenger
 */
    TAPWifiOnboardComponent.prototype.TAP_handleAddVoucher = function (targetPassengerIndex) {
        var newVal = this.TAP_chosenValueFromCollection(targetPassengerIndex);
        /**
        * Get the first stop and duplicate info for other flights
        */
        var passengerStop = Object.assign([], this.passengers[targetPassengerIndex].stops[0].wifi);
        if (!passengerStop) {
            var stops = this.passengers[targetPassengerIndex].stops.map(function (cur) { return Object.assign({}, cur, { wifi: [newVal] }); });
            this.passengers[targetPassengerIndex] = Object.assign(new PassengerFlightInfo(null, null), this.passengers[targetPassengerIndex], { stops: stops });
        }
        else {
            passengerStop.push(newVal);
            var stops = this.passengers[targetPassengerIndex].stops.map(function (cur) { return Object.assign({}, cur, { wifi: passengerStop }); });
            this.passengers[targetPassengerIndex] = Object.assign(new PassengerFlightInfo(null, null), this.passengers[targetPassengerIndex], { stops: stops });
        }
        this.formsPerPassenger[targetPassengerIndex] = this.createFormGroup();
        this.TAP_handleDoneStore();
    };
    TAPWifiOnboardComponent.prototype.passengerCanAddVoucher = function (index) {
        return true;
    };
    TAPWifiOnboardComponent.prototype.TAP_handleRemoveVoucher = function (passenger) {
        var currentPassenger = this.passengers[passenger];
        var wifi = currentPassenger.stops[0].wifi.slice();
        wifi.pop();
        var stops = currentPassenger.stops.map(function (cur) { return Object.assign({}, cur, { wifi: wifi }); });
        currentPassenger = Object.assign(new PassengerFlightInfo(null, null), currentPassenger, { stops: stops });
        this.passengers[passenger] = currentPassenger;
        this.TAP_handleDoneStore();
    };
    TAPWifiOnboardComponent.prototype.TAP_chosenValueFromCollection = function (targetPassengerIndex) {
        var value = this.TAP_chosenValue(targetPassengerIndex), collection = this.vouchersCollection;
        return collection.find(function (val) { return val.value === value; });
    };
    TAPWifiOnboardComponent.prototype.TAP_chosenValue = function (targetPassengerIndex) {
        var form = this.formsPerPassenger[targetPassengerIndex];
        return form.get('wifiAdd').value;
    };
    TAPWifiOnboardComponent.prototype.TAP_handleDoneStore = function () {
        this.flight = Object.assign(new Flight(null, null, null), this.flight, { passengerInfo: this.passengers });
        var flights = Object.assign([], [this.flight]);
        this.otherFlights.map(function (flight) { return flights.push(flight); });
        this.booking = Object.assign(new BookedTrip(null, null, null), this.booking, { flights: flights.sort(function (a, b) { return a.departure.time - b.departure.time; }) });
        this.store.dispatch(new BookedTripActions.PutBookedTripAction(this.booking));
    };
    TAPWifiOnboardComponent.prototype.TAP_printVoucherPrice = function (voucher) {
        var price = voucher.price;
        return (price * this.flight.stops_labels.length).toFixed(2) + environment.currency.symbol;
    };
    /**
     * Return the number of added items in this sidebar
     */
    TAPWifiOnboardComponent.prototype.TAP_printItemsCount = function () {
        var count = 0;
        this.passengers.forEach(function (passenger) {
            /**
             * Get the first stop and duplicate info for other flights
             */
            if (passenger.stops[0].wifi) {
                count += passenger.stops[0].wifi.length;
            }
        });
        return count;
    };
    /**
     * @returns print-ready string of value of added ancillaries
     */
    TAPWifiOnboardComponent.prototype.TAP_printTotal = function () {
        var total = 0;
        this.passengers.forEach(function (passenger) {
            passenger.stops.forEach(function (stop) {
                if (stop.wifi) {
                    total += stop.wifi.reduce(function (a, b) { return +a + +b.price; }, 0);
                }
            });
        });
        return total.toFixed(2) + environment.currency.symbol;
    };
    TAPWifiOnboardComponent.prototype.TAP_flowActionsClasses = function () {
        return { 'flow_actions--wide': !this.TAP_hasNextFlight() };
    };
    TAPWifiOnboardComponent.prototype.copyToOtherFlights = function () {
        var _this = this;
        var searchPassenger = function (id) { return _this.passengers.find(function (cur) { return cur.passenger.id == id; }); };
        var setSpecialItems = function (cur) {
            var infoPassenger = searchPassenger(cur.passenger.id);
            /**
            * Get the first stop and duplicate info for other flights
            */
            var wifi = infoPassenger.stops[0].wifi;
            if (wifi) {
                var stops = cur.stops.map(function (stop) { return Object.assign({}, stop, { wifi: wifi }); });
                cur = Object.assign(new PassengerFlightInfo(null, null), cur, { stops: stops });
            }
            return cur;
        };
        var flights = Object.assign([], [this.flight]);
        this.otherFlights.map(function (flight) {
            var newFlight = Object.assign(new Flight(null, null, null), flight, { passengerInfo: flight.passengerInfo.map(setSpecialItems) });
            flights.push(newFlight);
        });
        this.booking = Object.assign(new BookedTrip(null, null, null), this.booking, { flights: flights.sort(function (a, b) { return a.departure.time - b.departure.time; }) });
        this.store.dispatch(new BookedTripActions.PutBookedTripAction(this.booking));
        this.showNotification('Applied successfully to other flights');
    };
    TAPWifiOnboardComponent.prototype.showNotification = function (message) {
        this.notificationMessage = message;
        this.notificationShowing = true;
        window.setTimeout(this.dismissNotification.bind(this), this.notificationDuration * 1000);
        this.lastActiveElement = document.activeElement;
        this.$notification.nativeElement.focus();
    };
    TAPWifiOnboardComponent.prototype.dismissNotification = function () {
        this.notificationShowing = false;
        this.lastActiveElement.focus();
    };
    return TAPWifiOnboardComponent;
}(WifiOnboardComponent));
export { TAPWifiOnboardComponent };
